import { IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';

export class GsapPluginDto {
	@IsString()
	name: string;

	@IsBoolean()
	enabled: boolean;

	@IsOptional()
	@IsString()
	version?: string;

	@IsNumber()
	fileSize: number;

	@IsOptional()
	@IsString()
	cdnUrl?: string;
}